import {getApiBase} from '../../config/apiBase';
import buildHeaders from './fetchHeaders';

const API_BASE = getApiBase().replace(/\/$/, '') || '/api';

export async function listTeamGroups() {
    const response = await fetch(`${API_BASE}/team/groups`, {
        headers: buildHeaders({Accept: 'application/json'}),
    });
    if (!response.ok) {
        throw new Error(`listTeamGroups ${response.status}`);
    }
    const data = await response.json();
    return Array.isArray(data.groups) ? data.groups : [];
}

export async function searchTeam(query, {limit = 20, signal} = {}) {
    const params = new URLSearchParams({q: query || '', limit: String(limit)});
    const response = await fetch(`${API_BASE}/search/team?${params.toString()}`, {
        headers: buildHeaders({Accept: 'application/json'}),
        signal,
    });
    if (!response.ok) {
        throw new Error(`searchTeam ${response.status}`);
    }
    const data = await response.json();
    return Array.isArray(data.items) ? data.items : [];
}
